// Hook - widok kanban transakcji handlowca
// GET /api/ui/sales-crm/deals/kanban

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetDealsKanbanResponse } from 'api/types/deals';

export interface IUseGetDealsKanbanParams {
  /** `me`/null = aktualny user; konkretny id handlowca = jego transakcje. */
  traderId?: string;
  /** Filtr po kliencie. Null = wszyscy klienci. */
  clientId?: number;
}

const getDealsKanban = (params: IUseGetDealsKanbanParams): Promise<IGetDealsKanbanResponse> => {
  const query: Record<string, unknown> = {};
  if (params.traderId !== undefined && params.traderId !== null) {
    query.traderId = params.traderId;
  }
  if (params.clientId !== undefined && params.clientId > 0) {
    query.clientId = params.clientId;
  }
  return axios.get(`/sales-crm/deals/kanban`, { params: query });
};

export const useGetDealsKanban = (
  params: IUseGetDealsKanbanParams = {},
  options?: UseQueryOptions<IGetDealsKanbanResponse, IError>,
) =>
  useQuery<IGetDealsKanbanResponse, IError>(
    ['sales-crm-deals-kanban', params.traderId ?? 'me', params.clientId ?? null],
    () => getDealsKanban(params),
    options,
  );
